import { getInlineCssColor } from "../../utils/colors";
import { aceDividerCssVariables, getAceDividerNames } from "./ace-divider.get-names";
import { h } from "@stencil/core";
export class AceDivider {
    constructor() {
        this.color = 'borders--100';
        this.vertical = false;
    }
    componentWillLoad() {
        var _a;
        this.names = getAceDividerNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
    }
    render() {
        const finalCssStyles = {
            [aceDividerCssVariables.COLOR]: getInlineCssColor(this.color),
        };
        return (h("hr", { key: 'c143697e586a8aafa1716e20732faac6c8bc55b3', id: this.names.ID.ROOT, class: this.names.CLASS.ROOT, style: finalCssStyles }));
    }
    static get is() { return "ace-divider"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-divider.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-divider.css"]
        };
    }
    static get properties() {
        return {
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "color",
                "reflect": true,
                "defaultValue": "'borders--100'"
            },
            "vertical": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "vertical",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "hostElement"; }
}
//# sourceMappingURL=ace-divider.js.map
